import { Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { MetadataDetailFluentValue } from "byzantine/src/Account";

export interface InformationRowProps {
  /**
   * Formatted fluent string
   */
  label?: string | null;
  /**
   * Related variable that has been formatted or contents of a fluent string
   */
  value?: string | null | MetadataDetailFluentValue;
}

const InformationRow = ({ label, value }: InformationRowProps) => {
  const { l10n } = useLocalization();
  if (!label || !value) {
    return null;
  }

  const valueDisplay =
    typeof value === "string"
      ? value
      : l10n.getString(value.id, value.args, value.default);

  return (
    <div className="information-row">
      <Row alignItems="center">
        <Row.Item shrink>{label}</Row.Item>
        <Row.Item>
          <div style={{ textAlign: "right" }}>{valueDisplay}</div>
        </Row.Item>
      </Row>
    </div>
  );
};

export default InformationRow;
